import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledAttributesTable = styled.dl`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0;
  border: 1px solid #ccc;

  dt,
  dd {
    display: inline-block;
    width: 100%;
    margin: 0;
    padding: 1rem;
    box-sizing: border-box;
    border: 1px solid #ccc;

    &:nth-of-type(even) {
      background: #ddd;
    }
  }
`;

function boolToString(value) {
  return value ? 'True' : 'False';
}

function Attributes({ arr }) {
  return (
    <StyledAttributesTable>
      {arr.map(({ name, value }) => (
        <React.Fragment key={name}>
          <dt>
            {name}
          </dt>
          <dd>
            {boolToString(value)}
          </dd>
        </React.Fragment>
      ))}
    </StyledAttributesTable>
  );
}

Attributes.propTypes = {
  arr: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
  })).isRequired,
};

export default Attributes;



// WEBPACK FOOTER //
// ./src/Components/Attributes/index.jsx